import { numeratorFullLogo } from '@utilities/assets';
import { COLOR_NUMERATOR_GREEN } from '@utilities';

import { FONT_FACE, LINK_COLOR } from '../constants';

/**
 * Format the date to be more human readable.
 * @param {String} dateString
 * @returns {string}
 */
const formatDate = (dateString) => {
  const [year, month, day] = dateString.split('-');
  return `${month}/${day}/${year}`;
};

const demoMap = {
  age_bracket: 'Age (Brackets)',
  age_generation: 'Age (Generation)',
  gender: 'Gender (App Owner)',
  has_children_ages_0_5: 'Has Children (0-5)',
  has_children_ages_6_12: 'Has Children (6-12)',
  has_children_ages_13_17: 'Has Children (13-17)',
  income_dollars: 'Income $',
  language_preference_spoken: 'Language Preference (Spoken)',
  language_preference_tv: 'Language Preference (TV)',
  lgbtq: 'LGBTQ+?',
};

/**
 * Format shopperAttributes to fit expected text with answers.
 * @param {Object} shopperAttributes
 * @returns {string}
 */
const formatShopperAttributes = (shopperAttributes) => {
  let attributeText = [];
  for (const [attribute, filter] of Object.entries(shopperAttributes)) {
    switch (attribute) {
      case 'demographics_geography':
        for (const item of filter) {
          let demoCategory = '';
          if (Object.hasOwn(demoMap, item.attributeId)) {
            demoCategory = demoMap[item.attributeId];
          } else {
            demoCategory = item.attributeId
              .split('_')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          }
          attributeText.push(`${demoCategory}: ${item.name}`);
        }
        break;
      case 'media_consumption':
        for (const item of filter) {
          attributeText.push(`Media Consumption: ${item.name}`);
        }
        break;
      case 'psychographics':
        for (const item of filter) {
          attributeText.push(`Psychographics: ${item.name}`);
        }
        break;
    }
  }
  return attributeText.join(', ');
};

/**
 * Adds footer to the slide
 * @param {Object} pptx
 * @param {Array}  reportDateRange
 * @param {String} reportType
 * @param {String} reportUrl
 * @param {Object} shopperAttributes
 * @param {Object} slide
 */
export const addSlideFooter = ({
  pptx,
  reportDateRange,
  reportType,
  reportUrl,
  shopperAttributes,
  slide,
}) => {
  const hasValidReportDateRange =
    Array.isArray(reportDateRange) &&
    typeof reportDateRange[0] === 'string' &&
    reportDateRange[0].trim() &&
    typeof reportDateRange[1] === 'string' &&
    reportDateRange[1].trim();

  slide.addShape(pptx.ShapeType.rect, {
    fill: { color: COLOR_NUMERATOR_GREEN },
    h: 0.1,
    w: '100%',
    x: 0,
    y: '98.5%',
  });

  if (reportUrl && hasValidReportDateRange) {
    slide.addText('Source: Numerator Insights', {
      color: LINK_COLOR,
      fontFace: FONT_FACE,
      fontSize: 8,
      h: 0.1,
      x: 0.5,
      y: 5.05,
    });

    slide.addText([{ options: { hyperlink: { url: reportUrl } }, text: `${reportType}` }], {
      color: COLOR_NUMERATOR_GREEN,
      fontFace: FONT_FACE,
      fontSize: 8,
      h: 0.1,
      x: 1.9,
      y: 5.05,
    });

    let footerText = `Time Period - ${formatDate(reportDateRange[0])} to ${formatDate(reportDateRange[1])}`;
    if (shopperAttributes && Object.keys(shopperAttributes).length > 0) {
      const formattedAttributes = formatShopperAttributes(shopperAttributes);
      if (formattedAttributes.length > 325) {
        footerText += '; Shopper Attributes - See slide notes for details';
        slide.addNotes(`Shopper Attributes - ${formattedAttributes}`);
      } else {
        footerText += `; Shopper Attributes - ${formattedAttributes}`;
      }
    }
    slide.addText(footerText, {
      color: LINK_COLOR,
      fontFace: FONT_FACE,
      fontSize: footerText.length > 275 ? 6 : 8,
      h: 0.1,
      x: 0.5,
      y: 5.3,
    });
  }

  slide.addImage({
    h: 0.1903,
    path: numeratorFullLogo,
    w: 1.1,
    x: '83%',
    y: '90%',
  });
};
